import React from 'react';
import { useNoBodyScroll } from 'hooks/use-no-body-scroll';

const NoBodyScroll = () => {
    useNoBodyScroll();
    return null;
};

export default NoBodyScroll;